import type { FC, ReactNode } from "react"
import { memo } from "react"
import { Icon, IconNameType, IconPropsType } from "@/ui/Icon"
import { Description, StyledActionBar } from "./StyledActionBar"

export type VariantActionBarType = "blue" | "red"

export const ActionBar: FC<{
  icon?: IconNameType
  description: string | ReactNode
  variant?: VariantActionBarType
  iconSize?: IconPropsType["size"]
}> = memo(({ icon, description, variant = "blue", iconSize = "medium" }) => {
  return (
    <StyledActionBar variant={variant}>
      {icon && <Icon NameIcon={icon} size={iconSize} />}
      {!!description && <Description>{description}</Description>}
    </StyledActionBar>
  )
})

ActionBar.displayName = "ActionBar"
